import classNames from 'classnames';

const Column = ({className, size, children, ...props}) => (
    <div {...props} className={classNames(`col-lg-${size}`, className)}>
        {children}
    </div>
);

export default Column;
